import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCumNT7Hqg89JtAZyKf1nEzBO2nZNQx_R4",
  authDomain: "manter-invoxa.firebaseapp.com",
  projectId: "manter-invoxa",
  storageBucket: "manter-invoxa.appspot.com",
  messagingSenderId: "534520716070",
  appId: "1:534520716070:web:efd1a7b3d6305d11863fe7",
  measurementId: "G-19T3CC55D2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Configure Google Provider
const googleProvider = new GoogleAuthProvider();
// Add scopes for better user data access
googleProvider.addScope('email');
googleProvider.addScope('profile');
// Set custom parameters for the auth popup
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export { auth, googleProvider };